import React, { Component, Fragment } from 'react';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Card } from 'reactstrap';
import moment from 'moment';
import Icon from '~/components/icon/icon';
import TankTypeText from '~/components/tankTypeText/tankTypeText';
import ChangeLotTransferDateModal from '~/containers/changeLotTransferDateModal/changeLotTransferDateModal';
import ConfirmDryHopModal from '~/containers/confirmDryHopModal/confirmDryHopModal';
import TransferToBriteTankModal from '~/containers/transferToBriteTankModal/transferToBriteTankModal';
import ConfirmTransferToVesselModal from '~/containers/confirmTransferToVesselModal/confirmTransferToVesselModal';
import ConfirmClarificationModal from '~/containers/confirmClarificationModal/confirmClarificationModal';
import UserFullname from '~/components/userFullname/userFullname';
import styles from './styles.css';

export default class Transfer extends Component {
  state = {
    dropdownOpen: false,
    changeTransferDateModalOpen: false,
    confirmModalOpen: false
  };

  toggleDropdown = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  };

  toggleModal = name => {
    this.setState({
      [`${name}Open`]: !this.state[`${name}Open`]
    });
  };

  renderTank = () => {
    const { tankType, tank } = this.props.transfer;
    let nameText = '';
    if (tankType === 'BRITE_TANK' && tank) {
      nameText = <strong> {tank.name}</strong>;
    }

    return (
      <p>
        Transfer to{' '}
        <em>
          <TankTypeText type={tankType} />
          {nameText}
        </em>{' '}
      </p>
    );
  };

  renderVessel = () => {
    const { vesselDescription } = this.props.transfer;
    return (
      <p>
        Transfer to vessels <em>{vesselDescription}</em>
      </p>
    );
  };

  renderLocation = () => {
    const {
      location: { name }
    } = this.props.transfer;
    return (
      <p>
        Transfer to <em>{name}</em>
      </p>
    );
  };

  renderDryHop = () => {
    return <p>Dry hop</p>;
  };

  renderClarification = () => {
    return <p>Add clarification</p>;
  };

  renderIcon = () => {
    const { type } = this.props.transfer;
    switch (type) {
      case 'TANK':
        return <Icon icon="tank" className="stroke-divider" />;
      case 'VESSEL':
        return <Icon icon="wine-barrel" className="stroke-divider" />;
      case 'LOCATION':
        return <Icon icon="shelf" className="stroke-divider" />;
      case 'DRY_HOP':
        return <Icon icon="plant" className="stroke-divider" />;
      case 'CLARIFICATION':
        return <Icon icon="sparkle" className="stroke-divider" />;
      default:
        return <Icon icon="question-circle" className="stroke-divider" />;
    }
  };

  renderStatus = () => {
    const { transfer } = this.props;
    const className = styles[transfer.status.toLowerCase()];
    return <span className={`${className} ttu`}>{transfer.status.replace('_', ' ')}</span>;
  };

  renderCompletedBy = () => {
    const { transfer } = this.props;
    const { completedByUser, completedAt } = transfer;
    if (!completedAt) {
      return null;
    }

    return (
      <Fragment>
        <h4 className="table-header mv0">Completed By</h4>
        <p>
          <UserFullname user={completedByUser} /> on {moment(completedAt).format('ddd Do MMM')}
        </p>
      </Fragment>
    );
  };

  renderConformModal = () => {
    const { transfer, lot } = this.props;
    const { confirmModalOpen } = this.state;
    const sharedProps = {
      lotTransfers: [{ ...transfer, lot }],
      isOpen: confirmModalOpen,
      onSuccess: () => this.toggleModal('confirmModal'),
      onToggle: () => this.toggleModal('confirmModal'),
      refetchQueries: ['lot']
    };

    switch (transfer.type) {
      case 'TANK':
        if (transfer.tankType === 'BRITE_TANK') {
          return <TransferToBriteTankModal {...sharedProps} />;
        }
        return null;
      case 'VESSEL':
        return <ConfirmTransferToVesselModal {...sharedProps} />;
      case 'DRY_HOP':
        return <ConfirmDryHopModal {...sharedProps} />;
      case 'CLARIFICATION':
        return <ConfirmClarificationModal {...sharedProps} />;
      default:
        return null;
    }
  };

  renderDropdownOptions = () => {
    const { lot, transfer } = this.props;
    if (transfer.status === 'COMPLETED' || lot.status === 'COMPLETED') {
      return null;
    }

    return (
      <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown}>
        <DropdownToggle color="link" className="pa0">
          <Icon className={`ml3 stroke-text ${styles.icon}`} icon="navigation-menu-vertical" />
        </DropdownToggle>
        <DropdownMenu>
          <Fragment>
            <DropdownItem onClick={() => this.toggleModal('changeTransferDateModal')}>
              Change transfer date
            </DropdownItem>
            {lot.status === 'IN_PROGRESS' && (
              <DropdownItem onClick={() => this.toggleModal('confirmModal')}>Mark as complete</DropdownItem>
            )}
          </Fragment>
        </DropdownMenu>
      </ButtonDropdown>
    );
  };

  render = () => {
    const { transfer } = this.props;
    const { changeTransferDateModalOpen } = this.state;
    const transferMoment = moment(transfer.transferDate);
    const isWas = transferMoment.toDate() > new Date() ? 'is' : 'was';

    return (
      <Card key={transfer.id} className="pa3 mb4">
        <h4 className="f4 h-auto">{transfer.name}</h4>
        {transfer.shouldAutocomplete && <p className="ma0 f6 subtext">This step will autocomplete.</p>}
        <div className="absolute right-1 flex items-center">
          {this.renderStatus()}
          {this.renderDropdownOptions()}
        </div>
        <div className="flex mv2">
          <div className="mr3">{this.renderIcon()}</div>
          <div className="flex-grow-1">
            {transfer.type === 'TANK' && this.renderTank()}
            {transfer.type === 'VESSEL' && this.renderVessel()}
            {transfer.type === 'LOCATION' && this.renderLocation()}
            {transfer.type === 'DRY_HOP' && this.renderDryHop()}
            {transfer.type === 'CLARIFICATION' && this.renderClarification()}
            {transfer.notes && transfer.notes.length && <p>Notes: {transfer.notes}</p>}
          </div>
        </div>
        <p>
          This date for this transfer step {isWas} <strong>{transferMoment.format('ddd Do MMM')}</strong> (which is{' '}
          {transferMoment.fromNow()}
          ).{' '}
          {transfer.requiresDutyPaid && ' This transfer step also requires duty to be paid before it can be completed.'}
        </p>
        {this.renderCompletedBy()}
        <ChangeLotTransferDateModal
          transfer={transfer}
          isOpen={changeTransferDateModalOpen}
          onToggle={() => this.toggleModal('changeTransferDateModal')}
          onSuccess={() => this.toggleModal('changeTransferDateModal')}
          refetchQueries={['lot']}
        />
        {this.renderConformModal()}
      </Card>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/lotScheduleTransfers/transfer.jsx